import { render, staticRenderFns } from "./retrieve-password.vue?vue&type=template&id=2c72c268&scoped=true&"
import script from "./retrieve-password.vue?vue&type=script&lang=js&"
export * from "./retrieve-password.vue?vue&type=script&lang=js&"
import style0 from "./retrieve-password.vue?vue&type=style&index=0&id=2c72c268&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c72c268",
  null
  
)

export default component.exports